import { UnifyContentPackage } from '@csp/csp-common-content-models/src/lib/UnifyContentPackage';
import { merge } from 'lodash';
import { ContentstackConfigService } from '../../config/service/ContentstackConfigService';
import { ContentPackageType } from '../../model/ContentPackageType';

export const applyMockedContent = (
  packageType: ContentPackageType,
  contentPackage: UnifyContentPackage = {},
): UnifyContentPackage => {
  const allowMockedContent = ContentstackConfigService.get().allowMockedContent;
  const mockedContent = ContentstackConfigService.get().mockContent;
  if (allowMockedContent && mockedContent) {
    return merge({}, mockedContent[packageType], contentPackage);
  } else {
    return contentPackage;
  }
};
